import { render, staticRenderFns } from "./CategoryAttributeTypeSelect.vue?vue&type=template&id=813d9a08&scoped=true&"
import script from "./CategoryAttributeTypeSelect.vue?vue&type=script&lang=js&"
export * from "./CategoryAttributeTypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./CategoryAttributeTypeSelect.vue?vue&type=style&index=0&id=813d9a08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813d9a08",
  null
  
)

export default component.exports